export const summaryData = {
  packageDetails: {
    label: 'Package Details',
    column: [
      {
        key: 'trackingId',
        label: 'Tracking Id'
      },
      {
        key: 'orderNo',
        label: 'Order No'
      },
      {
        key: 'milestoneStatus',
        label: 'Milestone Status'
      },
      {
        key: 'milestoneRawStatus',
        label: 'Current Activity'
      },
      {
        key: 'lastUpdate',
        label: 'Date & Time',
        formatter: 'dateFormatterTZ'
      },
      {
        key: 'eta',
        label: 'ETA',
        formatter: 'dateFormatterTZ'
      },
      {
        key: 'packageStatus',
        label: 'Trip Status',
        formatter: 'startCase'
      },
      {
        key: 'exceptions',
        label: 'Exception'
      },
      {
        key: 'packageType',
        label: 'Package Type'
      },
      {
        key: 'volumetricWeight',
        label: 'Volumetric Weight'
      },
      {
        key: 'uomVolumetricWeight',
        label: 'Volumetric Weight Unit'
      },
      {
        key: 'dimensions',
        label: 'Package Dimension'
      },
      {
        key: 'groupId',
        label: 'Group Id'
      }
    ]
  },
  originDetails: {
    label: 'Origin Details',
    column: [
      {
        key: 'originDetails.city',
        label: 'City'
      },
      {
        key: 'originDetails.pincode',
        label: 'Pincode'
      },
      {
        key: 'originDetails.consignerName',
        label: 'Consigner'
      },
      {
        key: 'originDetails.consignerAddress',
        label: 'Consigner address'
      },
      {
        key: 'originDetails.consignerContact',
        label: 'Consigner contact no'
      },
      {
        key: 'originDetails.consignerEmail',
        label: 'Consigner email id'
      }
    ]
  },
  destinationDetails: {
    label: 'Destination Details',
    column: [
      {
        key: 'destinationDetails.city',
        label: 'City'
      },
      {
        key: 'destinationDetails.pincode',
        label: 'Pincode'
      },
      {
        key: 'destinationDetails.consigneeName',
        label: 'Consignee'
      },
      {
        key: 'destinationDetails.consigneeAddress',
        label: 'Consignee address'
      },
      {
        key: 'destinationDetails.consigneeContact',
        label: 'Consignee contact no'
      },
      {
        key: 'destinationDetails.consigneeEmail',
        label: 'Consignee email id'
      }
    ]
  },
  carrierDetails: {
    label: 'Carrier Details',
    column: [
      {
        key: 'carrierName',
        label: 'Carrier Name'
      },
      {
        key: 'carrierCode',
        label: 'Carrier Code'
      },
      {
        key: 'typeOfService',
        label: 'Service Type'
      }
    ]
  }
}

export const parcelConfig = {
  styling: {
    style: { background: '#F0F2F5' },
    layoutStyle: {},
    className: '',
    variant: {}
  },
  config: {
    tabsComponent: {
      summaryParcel: {
        showPackageDetails: true,
        label: 'Summary',
        component: 'summaryParcel',
        keyData: { ...summaryData }
      },
      parcelException: {
        showPackageDetails: true,
        label: 'Exceptions',
        component: 'parcelException'
      },
      parcelItemDetails: {
        showPackageDetails: false,
        label: 'Item Details',
        component: 'parcelItemDetails',
        columns: [
          {
            label: 'Item Id',
            key: 'itemReferenceNumber'
          },
          {
            label: 'Item Name',
            key: 'itemName'
          },
          {
            label: 'Quantity',
            key: 'itemQuantity'
          },
          {
            label: 'Child Awb No.',
            key: 'childAwbNo'
          },
          {
            label: 'Weight',
            key: 'itemWeight'
          },
          {
            label: 'Dimension',
            key: 'itemDimension'
          },
          {
            label: 'Volumetric Weight',
            key: 'itemVolumetricWeight'
          }
        ]
      },
      parcelEpod: {
        showPackageDetails: true,
        label: 'EPOD',
        component: 'parcelEpod'
      }
    },
    summaryURL: '/api/v1/parcels/',
    shareURL: `/api/v2/share_trips/share_link`,
    shareQueryParams: {
      resource_type: 'shipment',
      resource_id: ''
    },
    timeLineUrl: 'http://13.127.205.146:6567/parcel/timeline',
    subscribeURL: `/api/v3/trip/subscribe/`
  }
}
